import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription, CardFooter } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

interface NavigationCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  buttonText: string;
  onNavigate: () => void;
  className?: string;
}

const NavigationCard: React.FC<NavigationCardProps> = ({
  icon,
  title,
  description,
  buttonText,
  onNavigate,
  className,
}) => {
  return (
    <Card className={className}>
      <CardHeader className="p-2">
        <CardTitle className="flex items-center gap-2 text-sm">
          {icon} {title}
        </CardTitle>
      </CardHeader>
      <CardContent className="p-2 pt-0">
        <CardDescription className="text-xs">{description}</CardDescription>
      </CardContent>
      <CardFooter className="p-2 pt-0">
        <Button variant="link" className="p-0 text-sm" onClick={onNavigate}>
          {buttonText}
        </Button>
      </CardFooter>
    </Card>
  );
};

export default NavigationCard;